import React, { useEffect, useRef, useState } from 'react'
import { apiPost, apiPut } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import { useForm } from 'react-hook-form'
import ErrorMessage from '../../../components/ErrorMessage'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'

const Modal = ({ show, onHide, getAllQuestions, editData, setPage }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} })

  function Capitalize(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  }

  useEffect(() => {
    if (Object.keys(editData).length !== 0 && editData !== undefined) {
      setValue('question', Capitalize(editData.question) ?? '')
      setValue('optionA', Capitalize(editData.optionA) ?? '')
      setValue('optionB', Capitalize(editData.optionB) ?? '')
      setValue('optionC', Capitalize(editData.optionC) ?? '')
      setValue('optionD', Capitalize(editData.optionD) ?? '')
    }
  }, [editData])

  const handleSubmitForm = async (data) => {
    const createData = {
      // optionA: data.optionA.toLowerCase(),
      // optionB: data.optionB.toLowerCase(),
      // optionC: data.optionC.toLowerCase(),
      // optionD: data.optionD.toLowerCase(),
      question: data.question
    }
    if (Object.keys(editData).length === 0) {
      try {
        const res = await apiPost(apiPath.addQuestion, createData)
        if (res.data.success === true) {
          setPage(1)
          getAllQuestions()
          onHide()
          notification.success(res.data.message)
        } else {
          notification.error(res?.data.message)
        }
      } catch (err) {
        console.log('err:', err)
      }
    } else {
      try {
        const res = await apiPut(apiPath.editQuestion + '/' + editData._id, createData)
        if (res.data.success === true) {
            getAllQuestions()
          onHide()
          notification.success(res.data.message)
        } else {
          notification.error(res?.data.message)
        }
      } catch (err) {
        console.log('err:', err)
      }
    }
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <form className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[800px]' onSubmit={handleSubmit(handleSubmitForm)}>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{editData && Object.keys(editData)?.length ? t('EDIT_QUESTION') : t('ADD_QUESTION')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => onHide()}
                >
                  <span
                    className=' text-[#B8BBBF]  text-4xl '
                    title={t('O_CLOSE')}
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid grid-cols-1'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='question'
                        id='question'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={150}
                        {...register('question', {
                          required: t('VALIDATION_QUESTION_REQUIRED'),
                        //   pattern: {
                        //     value: validationRules.characters,
                        //     message: t('VALIDATION_CATEGORY_PATTERN')
                        //   },
                          validate: value => {
                            const val = value.trim()
                            return val.length < 10 
                            ? t('VALIDATION_QUESTION_MIN_LENGTH')
                            : true
                          }
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart()
                          setValue('question', value, { shouldValidate: true })
                        }}
                      />
                      <label
                        htmlFor='question'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_QUESTION')}<span className='text-red-500'>*</span>

                      </label>
                      <ErrorMessage message={errors?.question?.message} />
                    </div>
                  </div>
                </div>
                {/* <div className='grid grid-cols-2'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='optionA'
                        id='optionA'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={20}
                        {...register('optionA', {
                          required: t('VALIDATION_OPTION_A_REQUIRED'),
                          validate: (val) => {
                            let value = val.toLowerCase()
                            value = value.trim()
                            if (watch('optionB').toLowerCase() === value || watch('optionC').toLowerCase() === value || watch('optionD').toLowerCase() === value) {
                              return t('DUPLICATE_OPTION')
                            }
                          },
                        //   pattern: {
                        //     value: validationRules.characters,
                        //     message: t('VALIDATION_CATEGORY_PATTERN')
                        //   },
                        //   validate: value => {
                        //     const val = value.trim()
                        //     return val.length < 3 
                        //     ? t('VALIDATION_REPORT_REASON_MIN_LENGTH')
                        //     : true
                        //   }
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart()
                          setValue('optionA', value, { shouldValidate: true })
                        }}
                      />
                      <label
                        htmlFor='optionA'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_OPTION_A')}<span className='text-red-500'>*</span>

                      </label>
                      <ErrorMessage message={errors?.optionA?.message} />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='optionB'
                        id='optionB'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={20}
                        {...register('optionB', {
                          required: t('VALIDATION_OPTION_B_REQUIRED'),
                          validate: (val) => {
                            let value = val.toLowerCase()
                            value = value.trim()
                            if (watch('optionA').toLowerCase() === value || watch('optionC').toLowerCase() === value || watch('optionD').toLowerCase() === value) {
                              return t('DUPLICATE_OPTION')
                            }
                          },
                        //   pattern: {
                        //     value: validationRules.characters,
                        //     message: t('VALIDATION_CATEGORY_PATTERN')
                        //   },
                        //   validate: value => {
                        //     const val = value.trim()
                        //     return val.length < 3 
                        //     ? t('VALIDATION_REPORT_REASON_MIN_LENGTH')
                        //     : true
                        //   }
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart()
                          setValue('optionB', value, { shouldValidate: true })
                        }}
                      />
                      <label
                        htmlFor='optionB'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_OPTION_B')}<span className='text-red-500'>*</span>

                      </label>
                      <ErrorMessage message={errors?.optionB?.message} />
                    </div>
                  </div>
                </div>
                <div className='grid grid-cols-2'>
                <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='optionC'
                        id='optionC'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={20}
                        {...register('optionC', {
                          required: t('VALIDATION_OPTION_C_REQUIRED'),
                          validate: (val) => {
                            let value = val.toLowerCase()
                            value = value.trim()
                            if (watch('optionB').toLowerCase() === value || watch('optionA').toLowerCase() === value || watch('optionD').toLowerCase() === value) {
                              return t('DUPLICATE_OPTION')
                            }
                          },
                        //   pattern: {
                        //     value: validationRules.characters,
                        //     message: t('VALIDATION_CATEGORY_PATTERN')
                        //   },
                        //   validate: value => {
                        //     const val = value.trim()
                        //     return val.length < 3 
                        //     ? t('VALIDATION_REPORT_REASON_MIN_LENGTH')
                        //     : true
                        //   }
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart()
                          setValue('optionC', value, { shouldValidate: true })
                        }}
                      />
                      <label
                        htmlFor='optionC'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_OPTION_C')}<span className='text-red-500'>*</span>

                      </label>
                      <ErrorMessage message={errors?.optionC?.message} />
                    </div>
                  </div>
                <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0   w-full group'>
                      <input
                        type='text'
                        name='optionD'
                        id='optionD'
                        className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        maxLength={20}
                        {...register('optionD', {
                          required: t('VALIDATION_OPTION_D_REQUIRED'),
                          validate: (val) => {
                            let value = val.toLowerCase()
                            value = value.trim()
                            if (watch('optionB').toLowerCase() === value || watch('optionC').toLowerCase() === value || watch('optionA').toLowerCase() === value) {
                              return t('DUPLICATE_OPTION')
                            }
                          },
                        //   pattern: {
                        //     value: validationRules.characters,
                        //     message: t('VALIDATION_CATEGORY_PATTERN')
                        //   },
                        //   validate: value => {
                        //     const val = value.trim()
                        //     return val.length < 3 
                        //     ? t('VALIDATION_REPORT_REASON_MIN_LENGTH')
                        //     : true
                        //   }
                        })}
                        onChange={(event) => {
                          var value = event.target.value;
                          value = value.trimStart()
                          setValue('optionD', value, { shouldValidate: true })
                        }}
                      />
                      <label
                        htmlFor='optionD'
                        className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                      >
                        {t('O_OPTION_D')}<span className='text-red-500'>*</span>

                      </label>
                      <ErrorMessage message={errors?.optionD?.message} />
                    </div>
                  </div>
                </div> */}
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='bg-LightBlue text-white active:bg-emerald-600 font-normal uppercase text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                >
                  {editData && Object.keys(editData)?.length ? t('O_EDIT') : t('O_ADD')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default Modal